import { createSharedPathnamesNavigation } from 'next-intl/navigation'
import { useSearchParams } from 'next/navigation'

import { OMS_LOCALES } from './constants'

const navigation = createSharedPathnamesNavigation({
  locales: OMS_LOCALES,
})

const PRESERVED_PARAMS = ['referrer', 'utm_source', 'utm_medium']

export function useRouter() {
  const router = navigation.useRouter()
  const searchParams = useSearchParams()

  const mergeWithPreservedParams = (url: string) => {
    const preserved: Record<string, string> = {}
    PRESERVED_PARAMS.forEach((param) => {
      const value = searchParams?.get(param)
      if (value) preserved[param] = value
    })

    if (Object.keys(preserved).length === 0) return url

    const urlObj = new URL(url, window.location.origin)
    Object.entries(preserved).forEach(([key, value]) => {
      if (!urlObj.searchParams.has(key)) {
        urlObj.searchParams.set(key, value)
      }
    })

    return urlObj.pathname + urlObj.search
  }

  return {
    ...router,
    push: (url: string, options?: any) => {
      router.push(mergeWithPreservedParams(url), options)
    },
    replace: (url: string, options?: any) => {
      router.replace(mergeWithPreservedParams(url), options)
    },
  }
}

export const { Link: NextLink, redirect, usePathname } = navigation
